import React, {useState} from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useForm } from "react-hook-form"
import Form from 'react-bootstrap/Form';
import Alert from 'react-bootstrap/Alert';
import Card from 'react-bootstrap/Card';
import ListGroup from 'react-bootstrap/ListGroup';
import InputGroup from 'react-bootstrap/InputGroup';
import Button from 'react-bootstrap/Button';
import { ApiUrl, Headers } from '../services/ApiUrl'
import axios from 'axios'
import { Navigate, useNavigate } from 'react-router-dom'


const LoginUsuariosProyectos = ({user, setUser}) => {
    const[showInput, setShowInput]= useState(false);
    const {
        register,
        handleSubmit,    
        formState: { errors },
      } = useForm()
      const onSubmit = (data) => {
        //console.log(data)  
        let url = ApiUrl + 'users_proyectos?login=true&suffix=user';
        axios.post(url, data, {headers:Headers})
        .then( response =>{  
          //console.log(response);   
          // acá entró ok
            setUser({
                error: false,
                login:true,
                id_user:response.data.results[0].id_user,
                name_user: response.data.results[0].name_user,
                email_user: response.data.results[0].email_user,
                telefono: response.data.results[0].telefono,
                fecha_nac: response.data.results[0].fecha_nac,
                token_user: response.data.results[0].token_user,
                tipo_user: response.data.results[0].tipo_user,
                dni: response.data.results[0].dni,
                errorMsg: ""
            });     

            // Assign value to a key
            sessionStorage.setItem("sesion_PP", "true");     
        }
        ).catch( error=>{
            //console.log(error); 
            setUser({
                error: true,
                login:false,
                errorMsg: error.response.data.results
            })
            
  
        })           
      }  
      const navigate = useNavigate();
      const navegarTo = (destino) => {
          const destinourl = '/' + destino;
          navigate(destinourl);
      }          
      
      
  return (
    <div>
    

    { user.login===false &&      
    <Form onSubmit={handleSubmit(onSubmit)}>

        <Container style={{marginTop:'50px'}}>
            <Row>
                    <Col>  
                        <h1>Carga de proyectos del PP2023 y PP Joven 2023</h1>
                        <p>Ya finalizó la etapa de carga de proyectos</p>
                        <Button variant='outline-primary' disabled={true} onClick={()=>navegarTo('registrarusuario')}>Registrarme</Button>
                    </Col>
            </Row>

            <Row style={{marginTop:'30px'}}>
                <Col>   
                    <Card>
                        <Card.Header>Inicio de sesión</Card.Header>
                        <Card.Body> 
                            <ListGroup className="list-group-flush">

                                <ListGroup.Item>
                                    <Form.Group className="mb-3">
                                    <Form.Label size="lg">Correo electrónico</Form.Label>
                                    <Form.Control type="text" placeholder="Correo electrónico..." 
                                    {...register("email_user", {required:"El correo electrónico es obligatorio",  
                                    pattern: {
                                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                        message: "El formato del correo electrónico es incorrecto"
                                    }  
                                    })} 
                                    isInvalid={errors.email_user}
                                    autoComplete='nope' 
                                    
                                    />

                                    {errors.email_user &&
                                    <Alert style={{marginTop:'10px' }} variant="danger">
                                        {errors.email_user?.message}
                                    </Alert>
                                    }
                                     
                                    </Form.Group>                        

                                    <Form.Group className="mb-3">
                                    <Form.Label size="lg">Contraseña</Form.Label>
                                    <InputGroup className="mb-3">
                                    { showInput ?
                                    <Button variant="outline-secondary" id="button-addon2" onClick={()=>setShowInput(false)}>
                                        <i className="bi bi-eye-fill"></i>
                                    </Button>    
                                    :
                                    <Button variant="outline-secondary" id="button-addon2" onClick={()=>setShowInput(true)}>
                                        <i className="bi bi-eye-slash-fill"></i>
                                    </Button>                                     
                                    }                                
                                    <Form.Control type={showInput?'text':'password'} placeholder="Contraseña..." 
                                    {...register("password_user", 
                                    {required:"La contraseña es obligatoria", 
                                    minLength:{value:8, message: "El mínimo de caracteres para la contraseña es 8"}, 
                                    })} 
                                    isInvalid={errors.password_user}
                                    autoComplete='nope'
                                    maxLength='20'
                                    
                                    />
                                    
                                    </InputGroup>   

                                    {errors.password_user &&
                                    <Alert style={{marginTop:'10px' }} variant="danger">
                                        {errors.password_user?.message}
                                    </Alert>
                                    }
                                    </Form.Group>                        
                          
                                    <Button type="submit"style={{width:'200px'}}>Iniciar sesión</Button>
                                </ListGroup.Item>                                    

                                <ListGroup.Item> 
                                    <Alert variant="success">
                                        Para poder cargar un proyecto es necesario estar registrado en la plataforma.<br/>
                                        <strong><i className="bi bi-file-earmark-lock" style={{fontSize:'20px'}}></i> <a href="/pp2023/registrarusuario">Puede registrase haciendo click aquí </a></strong>
                                    </Alert>                       
                                </ListGroup.Item>  
                                <ListGroup.Item> 
                                    { user.error===true &&
                                            <Alert variant="danger">
                                                {user.errorMsg}
                                            </Alert>
                                    }   
                                </ListGroup.Item>                                                                                            

                            </ListGroup>
                        </Card.Body>
                    </Card>    
                </Col>
            </Row>
        </Container>
    </Form>
        }


            { user.login===true &&  
                <Navigate to="/panelusuarioproyectos" user={user} />
            }


    </div>

  )
}

export default LoginUsuariosProyectos